// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ValorServicosFranquias_SaveResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /config/valor_servicos_franquias/save.
 *
 * dados is the persisted pricing record echoed back
 * (Valor_servicos_franquias_model::save returns the record's to_object()),
 * matching the config_valor_servicos_franquias columns.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface ValorServicosFranquias_SaveResponseDados {
valorservicofranquia_id?: number
franquia_id?: number
servico_id?: number
servico_valor_padrao?: number
servico_valor_minimo?: number
}

export type ValorServicosFranquias_SaveResponse = ApiResponse<ValorServicosFranquias_SaveResponseDados>;

registerResponseContract('ValorServicosFranquias_SaveResponse', {
  valorservicofranquia_id: { type: 'number',  required: false },
  franquia_id:             { type: 'number',  required: false },
  servico_id:              { type: 'number',  required: false },
  servico_valor_padrao:    { type: 'number',  required: false },
  servico_valor_minimo:    { type: 'number',  required: false },
})
